export enum EmailStatus {
  error = 'error',
  success = 'success',
}
